module.exports = __webpack_public_path__ + "static/media/art-school.0cba80ff.svg";